(function (ng) {
    ng.module('evo.Compare.Services').factory('comparableProductService', ['$http', 'COMPARE_SERVICE_BASE',
        function ($http, COMPARE_SERVICE_BASE) {
            return {
                getComparableProduct: function (productPageIdOrSKU) {
                    return $http.get(COMPARE_SERVICE_BASE + productPageIdOrSKU).then(function (response) { return response.data; });
                }
            };
        }
    ]);
})(angular);